import { render, staticRenderFns } from "./UsersCreate.vue?vue&type=template&id=5a9fefeb&"
import script from "./UsersCreate.vue?vue&type=script&lang=ts&"
export * from "./UsersCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports